var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tank.wheels_id)?_c('menu-item',{attrs:{"label":"","tooltip-key":"tooltip_wheels"}},[_c('custom-checkbox',{attrs:{"label":_vm.$t('powerpack.valveMenu.wheels')},model:{value:(_vm.wheels),callback:function ($$v) {_vm.wheels=$$v},expression:"wheels"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }